import { IconWrapper } from '../runtime';
export default IconWrapper('document-shared-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2 2.64049C2 1.18246 3.18197 0.000488281 4.64 0.000488281L17.0665 0.000488758C17.7666 0.000488758 18.4381 0.278631 18.9332 0.773727L22.2268 4.06725C22.7219 4.56235 23 5.23384 23 5.93401V21.3605C23 22.8185 21.818 24.0005 20.36 24.0005H4.64C3.18197 24.0005 2 22.8185 2 21.3605V2.64049Z",
      "fill": 'url(#' + props.id + 'ad03cfa5' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M17.4961 0.000488281C18.2332 0.000488281 18.9401 0.293237 19.4615 0.814361L22.6807 4.03247C23.2028 4.55436 23.4961 5.2623 23.4961 6.00049H18.9961C18.1677 6.00049 17.4961 5.32891 17.4961 4.50049V0.000488281Z",
      "fill": "white",
      "fill-opacity": "0.3"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17.1875 9.8125C17.1875 10.7963 16.39 11.5938 15.4062 11.5938C14.9475 11.5938 14.5293 11.4204 14.2136 11.1356L12.2031 12.2758C12.2742 12.5046 12.3125 12.7478 12.3125 13C12.3125 13.2752 12.2669 13.5398 12.1828 13.7866L14.1834 14.986C14.5025 14.6847 14.9328 14.5 15.4062 14.5C16.39 14.5 17.1875 15.2975 17.1875 16.2812C17.1875 17.265 16.39 18.0625 15.4062 18.0625C14.4225 18.0625 13.625 17.265 13.625 16.2812C13.625 16.178 13.6338 16.0768 13.6507 15.9783L11.5832 14.7388C11.1434 15.1709 10.5403 15.4375 9.875 15.4375C8.52881 15.4375 7.4375 14.3462 7.4375 13C7.4375 11.6538 8.52881 10.5625 9.875 10.5625C10.5639 10.5625 11.1861 10.8483 11.6294 11.3078L13.6583 10.1571C13.6365 10.0456 13.625 9.93041 13.625 9.8125C13.625 8.82874 14.4225 8.03125 15.4062 8.03125C16.39 8.03125 17.1875 8.82874 17.1875 9.8125Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'ad03cfa5',
      "x1": "4.55391",
      "y1": "1.30055",
      "x2": "26.8934",
      "y2": "14.9599",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});